export function shouldFlashRoadResult({ previousTableKey, nextTableKey, previousSeq, nextSeq } = {}) {
  const tableUnchanged = String(previousTableKey ?? '') === String(nextTableKey ?? '');
  const previous = Math.max(0, Number(previousSeq) || 0);
  const next = Math.max(0, Number(nextSeq) || 0);
  return tableUnchanged && next > 0 && next !== previous;
}

export function resolveRoadModel(analysis = {}, mode = 'main') {
  const prediction = mode === 'banker'
    ? analysis?.ZhuangWenLu
    : mode === 'player'
      ? analysis?.XianWenLu
      : null;
  if (prediction && typeof prediction === 'object') {
    return {
      LuZhu: prediction.LuZhu || '',
      DaLu: prediction.DaLu || '',
      XiaoLu: Array.isArray(prediction.XiaoLu) ? prediction.XiaoLu : []
    };
  }
  return {
    LuZhu: analysis?.MainLuZhu || '',
    DaLu: analysis?.MainDalu || '',
    XiaoLu: Array.isArray(analysis?.MainXiaoLu) ? analysis.MainXiaoLu : []
  };
}

export function latestChangedVisibleRoadIndex(previousValue, nextValue, { sourceColumns = 40, visibleColumns = sourceColumns, visibleRows = 6 } = {}) {
  const previous = String(previousValue || '').split('@');
  const next = String(nextValue || '').split('@');
  const maximum = Math.min(next.length - 1, sourceColumns * visibleRows);
  for (let index = maximum; index >= 1; index -= 1) {
    const zeroBased = index - 1;
    const column = zeroBased % sourceColumns;
    const row = Math.floor(zeroBased / sourceColumns);
    if (column >= visibleColumns || row >= visibleRows) continue;
    const item = String(next[index] || '');
    if (item && item !== '0' && item !== String(previous[index] || '')) return index;
  }
  return -1;
}
